import { ContestsPageUserSettings, ContestDateFilters } from "user/contests-page-user-settings";

export const defaultContestDateFilters: ContestDateFilters = {
  startAtAfter: null,
  startAtBefore: null,
  endAtAfter: null,
  endAtBefore: null,
  createdAtAfter: null,
  createdAtBefore: null,
};

export function buildContestQueryParams(
  filters: ContestsPageUserSettings
): Record<string, string | string[]> {
  const params: Record<string, string | string[]> = {};

  if (filters.name) params.name = filters.name;
  if (filters.typeFilter) params.type = filters.typeFilter;
  if (filters.statusIn.length > 0) params["statusIn[]"] = filters.statusIn;
  if (filters.statusNotIn.length > 0) params["statusNotIn[]"] = filters.statusNotIn;

  const d = filters.dateFilters;
  if (d.startAtAfter) params.startAtAfter = d.startAtAfter;
  if (d.startAtBefore) params.startAtBefore = d.startAtBefore;
  if (d.endAtAfter) params.endAtAfter = d.endAtAfter;
  if (d.endAtBefore) params.endAtBefore = d.endAtBefore;
  if (d.createdAtAfter) params.createdAtAfter = d.createdAtAfter;
  if (d.createdAtBefore) params.createdAtBefore = d.createdAtBefore;

  if (filters.sort) {
    params.sortBy = `${String(filters.sort.property)}:${filters.sort.direction}`;
  }

  return params;
}

export function getActiveContestFilterCount(filters: ContestsPageUserSettings): number {
  let count = 0;
  if (filters.name) count++;
  if (filters.typeFilter) count++;
  if (filters.statusIn.length > 0) count++;
  if (filters.statusNotIn.length > 0) count++;
  count += Object.values(filters.dateFilters).filter(v => v !== null).length;
  return count;
}
